import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Button, Dropdown, Nav } from "react-bootstrap";
import TauriImage from "../../TauriImage/TauriImage";
import './CoverageView.css';
import "bootstrap/dist/css/bootstrap.min.css";
import OpalCoverageFactory from "./OpalCoverageFactory/OpalCoverageFactory";
import { addRecord, deleteRecord, deleteRecordByField, getAll, getNextId, getRecordById, updateRecord } from "../../../localDB";
import OpalAlertModal from "../../OpalAlertModal/OpalAlertModal";
import FinishSessionModal from "./FinishSessionModal/FinishSessionModal";
import AddRemarks from "./AddRemarks/AddRemarks";
import OpalAdvancedCallModal from "../../OpalAdvancedCallModal/OpalAdvancedCallModal";
import EvaluationSessionModal from "./EvaluationSessionModal/EvaluationSessionModal";
import { accountMapping, orderStatus, SessionTag, StockAllocationType, SyncStatusMap } from "../../../visualizations/visualizations";
import appURL from '../../../appURL.json';
import { useBaseProvider } from "../../../BaseManager/BaseManager";
import { statusMapping } from "../../../visualizations/visualizations";
import TauriLoader2 from "../../TauriLoader2/TauriLoader2";
import { useNavigate } from "react-router-dom";
import AccountSidebar from "../AccountSidebar/AccountSidebar";
import { CallPhase } from "../../../visualizations/visualizations";

const CoverageView = ({ id, setStartTime, selectedSession, sidebarLoading }) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [details, setDetails] = useState();
    const [item, setItem] = useState();
    const [showAddNotes, setShowAddNotes] = useState(false);
    const [showConfirmFinishSession, setShowConfirmFinishSession] = useState(false);
    const [showConfirmFinishEvaluation, setShowConfirmFinishEvaluation] = useState(false);
    const [showLocationMesaage, setShowLocationMesaage] = useState(false);
    const [isFinishing, setIsFinishing] = useState(false);
    const [isAddNote, setIsAddNote] = useState(null);
    const [showValidation, setShowValidation] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [showAdvancedCall, setShowAdvancedCall] = useState(false);
    const [timeIn, setTimeIn] = useState(false);
    const [timeOut, setTimeOut] = useState(false);
    const [missedCallReason, setMissedCallReason] = useState(null);
    const [showEvaluation, setShowEvaluation] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [signData, setSignData] = useState(null);
    const [photoImgData, setPhotoImgData] = useState(null);
    const [accountSchedules, setAccountSchedules] = useState([]);
    const [isLoadingAccountSchedules, setLoadingAccountSchedules] = useState(false);
    const [userLocation, setUserLocation] = useState(null);
    const [showAccountSidebar, setShowAccountSidebar] = useState(false);
    const [loadingAddNotes, setLoadingAddNotes] = useState(false);
    const [noInventory, setNoInventory] = useState(false);
    const [activeTab, setActiveTab] = useState(false);

    const navigate = useNavigate();

    const isRunningRef = useRef(false);

    const { isSync, setIsSidebarCollapsed } = useBaseProvider();

    const isOnline = JSON.parse(localStorage.getItem("isOnline"));
    const hasInternet = navigator.onLine;

    const storedPermission = localStorage.getItem("permission");
    const ext_id = localStorage.getItem("ext_id");
    const permission = JSON.parse(atob(storedPermission));

    const statusIcon = {
        0: "/Images/material-symbols--pending-actions.svg",
        1: "/Images/material-symbols--check.svg",
        2: "/Images/akar-icons--person-cross.svg",
        3: "/Images/mdi--hourglass.svg",
        4: "/Images/mdi--check-decagram.svg",
        5: "/Images/material-symbols--check-advanced.svg",
        8: "/Images/mdi--account-check-outline.svg",
    };

    const sections = [
        {
            "id": 0,
            "type": "inventory",
            "header": "Inventory",
            "icon": "/Images/outline-inventory.svg",
            "show": permission?.coverage?.inventory && selectedSession?.Customer?.Type === accountMapping.Customer
        },
        {
            "id": 1,
            "type": "samples",
            "header": "Samples",
            "icon": "/Images/outline-inventory.svg",
            "show": permission?.coverage?.samples
        },
        {
            "id": 2,
            "type": "withdrawal",
            "header": "Withdrawals",
            "icon": "/Images/material-symbols--add-notes-outline.svg",
            "show": permission?.coverage?.withdrawals
        },
        {
            "id": 3,
            "type": "order",
            "header": "Orders",
            "icon": "/Images/outline-inventory.svg",
            "show": permission?.coverage?.create_orders
        },
        {
            "id": 4,
            "type": "file",
            "header": "Files & Detailing",
            "icon": "/Images/material-symbols--attach-file-rounded.svg",
            "show": permission?.coverage?.detailing
        },
        {
            "id": 5,
            "type": "reminder",
            "header": "Reminders and Notes",
            "icon": "/Images/material-symbols--add-notes-outline.svg",
            "show": true
        }
    ];

    const tabSectionMap = {
        [CallPhase.PreCall]: ["samples", "file", "reminder"],
        [CallPhase.ActualCall]: ["inventory", "order", "withdrawal"],
        [CallPhase.PostCall]: ["reminder"]
    };

    const filteredSections = useMemo(() => {
        const allowed = tabSectionMap[activeTab] || [];
        return sections.filter(s => allowed.includes(s.type));
    }, [activeTab, sections]);

    const [modalOpen, setModalOpen] = useState(false);

    const fetchAccountSchedules = async () => {
        try {
            setLoadingAccountSchedules(true);
            const getSes = await getRecordById("session", Number(id));
            const cpID = localStorage.getItem("c_id");
            const sessions = await getAll("session");

            const filteredSessions = sessions
                .filter((session) => {
                    const sessionDate = new Date(session.SessionDate);
                    sessionDate.setHours(0, 0, 0, 0);  // Normalize the session date to 00:00:00

                    // Return the condition as true or false
                    return (
                        session.SyncStatus !== SyncStatusMap.done &&
                        session.AccountID === getSes.AccountID &&
                        session.CyclePeriodID === Number(cpID) &&
                        session.Tag == null
                    );
                })
                .sort((a, b) => new Date(a.SessionDate) - new Date(b.SessionDate));

            setAccountSchedules(
                filteredSessions.map(s => ({
                    SessionDate: s.SessionDate,
                    ID: s.ID,
                    AccountID: s.AccountID,
                    Status: s.Status,
                    Joint: s.Joint
                }))
            );
        } catch (error) {
            setAccountSchedules([]);
            console.log(error);
        } finally {
            setLoadingAccountSchedules(false);
        }
    };

    const handleSelectSchedule = (item) => {
        const selectedSessionDate = new Date(selectedSession?.SessionDate);
        selectedSessionDate.setHours(0, 0, 0, 0);

        const sessDate = new Date(item.SessionDate);
        sessDate.setHours(0, 0, 0, 0);

        if (selectedSessionDate.getTime() === sessDate.getTime()) return;

        localStorage.setItem("dateSelect", JSON.stringify(sessDate));

        //to prevent the initial load to select the first item in sidebar 
        window.dispatchEvent(new Event("dateSelect"));

        // setIsSidebarCollapsed(true);
        localStorage.setItem("preventNavigation", true);
        setTimeout(() => {
            window.dispatchEvent(new Event("session"));
        }, 100);
        navigate(`/coverage/${item.ID}`);
    }

    const formatSchedulesDisplayDate = (date) =>
        new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
        });

    useEffect(() => {
        fetchAccountSchedules();
        if (selectedSession?.Customer?.Type === accountMapping.Agent && selectedSession?.Status === statusMapping.inprogress) {
            setShowEvaluation(true);
        }
    }, [selectedSession]);

    const fetchData = useCallback(async () => {
        try {
            const cust = await getAll("customer");
            const ints = await getAll("institution");
            const session = await getRecordById('session', Number(id));
            const custData = cust.find((a) => a.ID === session?.AccountID);
            const instData = ints.find((a) => a.ID === custData?.InstitutionID);
            const reason = await getRecordById("MissedCallReasons", session?.MissedCallReasonID);
            setDetails({
                ...custData,
                InstitutionName: instData?.Name
            });
            setItem(session);
            setMissedCallReason(reason);

            window.dispatchEvent(new Event("refreshSession"));
        } catch (error) {
            setValidationMessage("Details not found!");
            setShowValidation(true);
        }
    }, [id, setDetails, setItem, setMissedCallReason, setValidationMessage, setShowValidation]);

    const handleStart = async () => {
        setIsLoading(true);
        try {
            if (details?.Type === 3 && !permission?.coverage?.joint_calls) {
                setValidationMessage("Invalid Permission");
                setShowValidation(true);
                return;
            }

            const { latitude, longitude, address } = await getLocation();

            const session = await getRecordById('session', Number(id));

            if (!session) throw new Error(`Session not found.`);

            const now = new Date(new Date().setHours(0, 0, 0, 0));
            const sessionDate = new Date(new Date(session.SessionDate).setHours(0, 0, 0, 0));

            let RecoverySessionID = session.RecoverySessionID;
            let PastDueSessionID = session.PastDueSessionID;

            session.ActualLocationLat = latitude;
            session.ActualLocationLong = longitude;
            session.ActualLocation = address ?? userLocation?.address;

            if (sessionDate > now && !session.AdvancedSessionID) {

                if (!permission?.coverage?.advanced_calls) {
                    setValidationMessage("You don't have the permission to do this action.");
                    setShowValidation(true);
                    return;
                }

                setShowAdvancedCall(true);
                setShowConfirm(false);
                return;
            }
            else if (sessionDate < now && !session.RecoverySessionID) {
                if (!permission?.coverage?.recover_calls) {
                    setValidationMessage("You don't have the permission to do this action.");
                    setShowValidation(true);
                    return;
                }

                RecoverySessionID = await CreateRecoveryCallSession(session);
            }

            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            let result = null;
            if (isOnline && hasInternet) {
                result = await OnlineStartSession(session);
                if (result?.error) {
                    setValidationMessage(result.error);
                    setShowValidation(true);
                    return; //
                }
            } else {
                session.SyncStatus = SyncStatusMap.update;
            }

            setStartTime(new Date().toISOString());

            session.RecoverySessionID = RecoverySessionID;
            session.PastDueSessionID = PastDueSessionID;
            session.ActualStart = result?.serverDate ?? new Date().toISOString();
            session.Status = statusMapping.inprogress //In Progress
            await updateRecord('session', session);

            setIsSidebarCollapsed(true);
            localStorage.setItem("preventNavigation", true);
            window.dispatchEvent(new Event("session"));

            await fetchData();
            setShowConfirm(false);

            if (details?.Type === accountMapping.Agent && permission?.coverage?.joint_calls) {
                setShowEvaluation(true);
            }
        } catch (err) {
            setValidationMessage("Failed to update!");
            setShowValidation(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleEnd = async () => {
        setShowConfirm(false);

        if (details?.Type === accountMapping.Agent && permission?.coverage?.joint_calls) {
            setShowEvaluation(true);
        } else {
            setModalOpen(true);
        }
    };

    const OnlineStartSession = async (a) => {
        try {
            const { latitude, longitude } = await getLocation();

            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");

            const requestBody = {
                ID: a.ID.toString(),
                VersionID: a?.VersionID,
                Location: {
                    lat: latitude,
                    long: longitude
                }
            };

            const response = await fetch(appURL.API_StartSession, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                    "X-ETR-DeviceID": devId
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (!response.ok) {
                if (data?.code) {
                    return { error: data?.description || "Session failed to start." };
                } else {
                    return { error: "Unexpected server error." };
                }
            }

            return { serverDate: data?.server_date }; // ✅ Return on success

        } catch (error) {
            console.error("Error starting session:", error);
            return { error: "Network or system error." };
        }
    };

    const checkLocationPermission = async () => {
        return new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    if (pos?.coords?.latitude && pos?.coords?.longitude) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                },
                () => resolve(false),
                {
                    enableHighAccuracy: true, // always try GPS if available
                    timeout: 20000,
                    maximumAge: 0
                }
            );
        });
    };

    const getLocation = async () => {
        return new Promise((resolve, reject) => {

            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    let address = null;

                    if (isOnline && hasInternet) {
                        try {
                            const token = localStorage.getItem("token");
                            const response = await fetch(`${appURL.API_GetLocationAddress}?lat=${latitude}&long=${longitude}`, {
                                method: "GET",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${token}`,
                                }
                            });

                            const data = await response.json();

                            address = data;
                        } catch (err) {
                            console.error("Reverse geocoding failed:", err);
                        }
                    }
                    setUserLocation({ latitude, longitude, address })
                    resolve({ latitude, longitude, address });
                },
                (error) => {
                    console.error(error);
                    resolve({ latitude: null, longitude: null, address: null });
                },
                {
                    enableHighAccuracy: true,
                    timeout: 20000, // stop waiting forever
                    maximumAge: 0
                }
            );
        });
    };

    function getExtensionFromBlob(blob) {
        if (!blob || !blob.type) return '';
        const mime = blob.type; // e.g., "image/png"
        const ext = mime.split('/')[1]; // get "png"
        return ext || '';
    }

    function formatDateForFilename(date = new Date()) {
        const pad = (num) => String(num).padStart(2, '0');
        return (
            date.getFullYear().toString() +
            pad(date.getMonth() + 1) +
            pad(date.getDate()) +
            pad(date.getHours()) +
            pad(date.getMinutes()) +
            pad(date.getSeconds())
        );
    }

    function formattedDisplayDate(date) {
        if (!date) return '';

        const converttoDate = new Date(date);
        const format = converttoDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).replace(',', ''); // remove the comma after the day

        return format
    }

    const CreateRecoveryCallSession = async (session) => {
        try {
            const sessionID = await getNextId("session");

            const allItems = (await getAll("sessionItems")).filter(x => x.SyncStatus !== SyncStatusMap.done);
            const allNotes = (await getAll("sessionNotes")).filter(x => x.SyncStatus !== SyncStatusMap.done);
            const allItemInventories = (await getAll("SessionInventory")).filter(x => x.SyncStatus !== SyncStatusMap.done);
            const allInventoryImages = (await getAll("InvImages")).filter(x => x.SyncStatus !== SyncStatusMap.done);
            const allItemForRequests = (await getAll("SessionForRequest")).filter(x => x.SyncStatus !== SyncStatusMap.done);

            const sessionItems = allItems.filter((item) => item.SessionID === session.ID);
            const sessionNotes = allNotes.filter((item) => item.SessionID === session.ID);
            const sessionItemInventory = allItemInventories.filter((item) => item.SessionID === session.ID);
            const sessionInventoryImages = allInventoryImages.filter((item) => item.SessionID === session.ID);
            const sessionItemForRequests = allItemForRequests.filter((item) => item.SessionID === session.ID);

            const date = new Date();

            const sessionRecoveryCall = {
                ...session,
                ID: sessionID,
                SessionDate: date.toLocaleDateString('en-CA'),
                ActualStart: new Date().toISOString(),
                ActualLocationLat: session?.ActualLocationLat ?? userLocation?.latitude,
                ActualLocationLong: session?.ActualLocationLong ?? userLocation?.longitude,
                ActualLocation: session?.ActualLocation ?? userLocation?.address,
                Status: statusMapping.pending,
                Tag: SessionTag.recovered, //recover
                SyncStatus: SyncStatusMap.create
            }

            await addRecord('session', sessionRecoveryCall);

            const today = new Date();
            // add Session items 
            for (const item of sessionItems) {
                const nextID = await getNextId("sessionItems");
                const newItem = {
                    ...item,
                    ID: nextID,
                    SessionID: sessionID,
                    SyncStatus: SyncStatusMap.create
                };
                await addRecord("sessionItems", newItem);
            }

            // Add Session Notes
            for (const note of sessionNotes) {
                const nextID = await getNextId("sessionNotes");
                const newNote = {
                    ...note,
                    ID: nextID,
                    CreatedDate: today.toISOString(),
                    SessionID: sessionID,   // reference to new session
                    SyncStatus: SyncStatusMap.create
                };
                await addRecord("sessionNotes", newNote);
            }

            // Add Session Item Inventory
            for (const inv of sessionItemInventory) {
                const nextID = await getNextId("SessionInventory");
                const newInv = {
                    ...inv,
                    ID: nextID,
                    SessionID: sessionID,
                    SyncStatus: SyncStatusMap.create
                };
                await addRecord("SessionInventory", newInv);
            }

            // Add Session Inventory Images
            for (const img of sessionInventoryImages) {
                const nextID = await getNextId("InvImages");
                const newImg = {
                    ...img,
                    ID: nextID,
                    SessionID: sessionID,
                    SyncStatus: SyncStatusMap.create
                };
                await addRecord("InvImages", newImg);
            }

            // Add Session Item For Requests
            for (const fr of sessionItemForRequests) {
                const nextID = await getNextId("SessionForRequest");
                const newFR = {
                    ...fr,
                    ID: nextID,
                    SessionID: sessionID,
                    SyncStatus: SyncStatusMap.create
                };
                await addRecord("SessionForRequest", newFR);
            }

            return sessionID;
        } catch (err) {
            console.error('Failed to create recover call reference!');
            return null;
        }
    };

    const UpdateAdvancedCallSession = async (session) => {
        try {
            const advancedSession = await getRecordById("session", session.AdvancedSessionID);

            advancedSession.Status = advancedSession.Joint != null
                ? statusMapping.successjointcall
                : statusMapping.success;

            advancedSession.ActualStart = session.ActualStart;
            advancedSession.ActualEnd = session.ActualEnd;
            advancedSession.EndSessionLatitude = session.EndSessionLatitude;
            advancedSession.EndSessionLongitude = session.EndSessionLongitude;
            advancedSession.EndSessionLocation = session.EndSessionLocation;
            advancedSession.Duration = session.Duration;
            advancedSession.RecipientPhotoFileID = session.RecipientPhotoFileID;
            advancedSession.RecipientSignatureFileID = session.RecipientSignatureFileID;

            await updateRecord('session', advancedSession);
        } catch (err) {
            console.error('Failed to create advanced call reference!', err);
            return null;
        }
    };

    const UpdateRecoveryCallSession = async (session) => {
        try {
            const recoverySession = await getRecordById("session", session.RecoverySessionID);
            const pastDueSession = await getRecordById("session", session.PastDueSessionID);

            if (recoverySession) {
                recoverySession.PastDueSessionID = session.PastDueSessionID;
                recoverySession.Status = session.Status;
                recoverySession.ActualStart = session.ActualStart;
                recoverySession.ActualEnd = session.ActualEnd;
                recoverySession.EndSessionLatitude = session.EndSessionLatitude;
                recoverySession.EndSessionLongitude = session.EndSessionLongitude;
                recoverySession.EndSessionLocation = session.EndSessionLocation;
                recoverySession.Duration = session.Duration;
                recoverySession.RecipientPhotoFileID = session.RecipientPhotoFileID;
                recoverySession.RecipientSignatureFileID = session.RecipientSignatureFileID;

                await updateRecord('session', recoverySession);
            }

            //past due session update details
            if (pastDueSession) {
                pastDueSession.RecoverySessionID = session.RecoverySessionID;
                pastDueSession.Status = session.Status;
                pastDueSession.ActualStart = session.ActualStart;
                pastDueSession.ActualEnd = session.ActualEnd;
                pastDueSession.EndSessionLatitude = session.EndSessionLatitude;
                pastDueSession.EndSessionLongitude = session.EndSessionLongitude;
                pastDueSession.EndSessionLocation = session.EndSessionLocation;
                pastDueSession.Duration = session.Duration;
                pastDueSession.RecipientPhotoFileID = session.RecipientPhotoFileID;
                pastDueSession.RecipientSignatureFileID = session.RecipientSignatureFileID;

                await updateRecord('session', pastDueSession);
            }

        } catch (err) {
            console.error(err);
            return null;
        }
    };

    const ClearSessionLocalData = async (sessionId) => {

        const order = await getOrderBySessionId(sessionId);

        await deleteRecordByField('SessionWithdrawal', 'SessionID', sessionId);
        await deleteRecordByField('SessionInventory', 'SessionID', sessionId);
        await deleteRecordByField('sessionItems', 'SessionID', sessionId);
        if (order) {
            await deleteRecordByField('OrderDetails', 'OrderID', Number(order?.ID));
            await deleteRecordByField("Orders", "SessionID", sessionId);
        }
    };

    const handleRemarks = async (message) => {
        try {
            setLoadingAddNotes(true);
            const session = await getRecordById('session', Number(id));
            if (isOnline && hasInternet) {
                const token = localStorage.getItem("token");
                const devId = localStorage.getItem("devId");

                const today = new Date();
                today.toISOString()

                const requestBody = {
                    id,
                    content: message,
                    phase: activeTab
                };

                const response = await fetch(appURL.API_AddSessionNotes, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        "X-ETR-Device-ID": devId
                    },
                    body: JSON.stringify(requestBody)
                });

                if (!response.ok) {
                    setValidationMessage("Failed to add notes!");
                    setShowValidation(true);
                    return;
                }
            } else {
                await CreateNotes(message, Number(id));
            }


            if (session.AdvancedSessionID) {
                const advanceSession = await getRecordById('session', session.AdvancedSessionID);

                await updateRecord('session', advanceSession);
                await CreateNotes(message, session.AdvancedSessionID);
            } else if (session.PastDueSessionID) {
                const pastDueSession = await getRecordById('session', session.PastDueSessionID);
                const recoveryDueSession = await getRecordById('session', session.RecoverySessionID);

                await updateRecord('session', pastDueSession);
                await updateRecord('session', recoveryDueSession);

                await CreateNotes(message, session.PastDueSessionID);
                await CreateNotes(message, session.RecoverySessionID);
            }

            localStorage.setItem("preventNavigation", true);
            window.dispatchEvent(new Event("session"));
            await fetchData();
        } catch (err) {
            setValidationMessage("Failed to add notes!");
            setShowValidation(true);
            return;
        } finally {
            setLoadingAddNotes(false);
            setShowAddNotes(false);
        }
    };

    const CreateNotes = async (message, sessionID) => {
        const SessionNoteID = await getNextId("sessionNotes");
        const today = new Date();
        const newNoteToSave = {
            ID: SessionNoteID,
            Content: message,
            ContentType: 1,
            ReminderDate: today.toISOString().split("T")[0],
            ReminderTime: today.toISOString().split("T")[1],
            CreatedDate: today.toISOString(),
            ReminderLocation: null,
            SessionID: sessionID,
            Phase: activeTab,
            SyncStatus: SyncStatusMap.create
        };

        await addRecord("sessionNotes", newNoteToSave);
    }

    useEffect(() => {
        const fetchDataAndLocation = async () => {
            try {
                await fetchAccountSchedules();
                await fetchData();
                const location = await checkLocationPermission();
                if (!location) {
                    setShowLocationMesaage(true);
                }

                await getLocation();
            } catch (err) {
                console.error("Failed to get location:", err);
            }
        };

        fetchDataAndLocation();

        const handleSessionChange = async () => {
            await fetchData();
        };

        window.addEventListener("session", handleSessionChange);

        return () => {
            window.removeEventListener("session", handleSessionChange);
        };
    }, [id]);

    useEffect(() => {
        const checkAttendance = async () => {
            try {
                const todayDate = new Date();
                todayDate.setHours(0, 0, 0, 0);

                const attendance = await getAll("Attendance");
                const todayAttendance = attendance
                    .filter(a => a.SyncStatus !== SyncStatusMap.done)
                    .find((a) => {
                        const timeInDate = new Date(a?.TimeIn);
                        timeInDate.setHours(0, 0, 0, 0); // normalize

                        return timeInDate.getTime() === todayDate.getTime();
                    });

                setTimeIn(todayAttendance?.TimeIn ? true : false);
                setTimeOut(todayAttendance?.TimeOut ? true : false);

            } catch (error) {
                setValidationMessage("attendance not found!");
                setShowValidation(true);
            }
        };

        checkAttendance();
    }, [])

    const onFinishSession = useCallback(async (captureImage, signatureImage, addNotes) => {
        if (isRunningRef.current) return;
        isRunningRef.current = true;

        setIsFinishing(true);
        try {

            if (selectedSession?.Customer?.Type === accountMapping.Customer) {
                const sessionInventories = await getAll("SessionInventory");
                const inventory = sessionInventories.filter(
                    a => a.SessionID === Number(id)
                );

                if (inventory.length === 0 && permission?.coverage?.inventory) {
                    setIsAddNote(true);
                    setNoInventory(true);
                } else {
                    setIsAddNote(false);
                    setNoInventory(false);
                }
            }


            const order = await getOrderBySessionId(Number(id));
            let isOnlineOrder = false;

            if (order) {
                const orderDetails = await getAll("OrderDetails");
                const orderItems = orderDetails.filter(a => a.OrderID === order?.ID);

                if (!orderItems || orderItems.length === 0) {
                    setValidationMessage("Your order has no items. Please add at least one item to proceed.");
                    setShowValidation(true);
                    return;
                }

                if (selectedSession?.Customer?.Type === accountMapping.Customer && !order?.Authorizer?.trim()) {
                    setValidationMessage("Authorized person on this order is required before finishing this session.");
                    setShowValidation(true);
                    return;
                }

                if (!signatureImage) {
                    setValidationMessage("Please provide a signature for this order before proceeding.");
                    setShowValidation(true);
                    return;
                }
            }

            const session = await getRecordById('session', Number(id));
            if (!session) throw new Error(`Session not found.`);


            const now = new Date();

            const { latitude, longitude, address } = await getLocation();

            const loc = {
                "lat": latitude,
                "long": longitude
            }

            const imageExt = getExtensionFromBlob(captureImage) || 'png';
            const signatureExt = getExtensionFromBlob(signatureImage) || 'png';

            const customer = await getRecordById("customer", session.AccountID);
            const formattedDate = formatDateForFilename(now);

            const sign = {
                ImageData: signatureImage || "",
                FileName: `s_${session.AgentID}_${formattedDate}_${customer?.Code}.${signatureExt}`
            }

            const photo_img = {
                ImageData: captureImage || "",
                FileName: `${session.AgentID}_${formattedDate}_${customer?.Code}.${imageExt}`
            }

            let result = null;
            if (isOnline && hasInternet) {
                result = await OnlineEndSession(session, loc, sign, photo_img);

                if (result?.error) {
                    setValidationMessage(result.error);
                    setShowValidation(true);
                    return; //
                }

                if (order) {
                    isOnlineOrder = true;
                }

            } else if (!isOnline || !hasInternet) {
                session.SyncStatus = SyncStatusMap.update;
            }

            const RecipientPhotoFileID = await getNextId("RecipientPhotoFile");
            const RecipientSignatureFileID = await getNextId("RecipientSignatureFile");

            const sessionDate = new Date(session.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            session.ActualEnd = result?.serverDate ?? now.toISOString();

            const start = new Date(session.ActualStart);
            const end = new Date(now.toISOString());

            const durationMs = end - start;
            const totalSeconds = +(durationMs / 1000).toFixed(4);

            session.Duration = result?.duration ?? totalSeconds;
            const today = now.setHours(0, 0, 0, 0);
            if (sessionDate < today || session.PastDueSessionID) {
                session.Status = statusMapping.recovered;
            } else if (sessionDate > today || session.PastDueSessionID) {
                session.Status = statusMapping.advanced;
            } else {
                session.Status = statusMapping.success;
            }

            if (captureImage) {
                session.RecipientPhotoFileID = RecipientPhotoFileID;
                const newRecipientPhotoFile = {
                    ID: RecipientPhotoFileID,
                    SessionID: Number(id),
                    ImageData: photo_img.ImageData,
                    FileName: photo_img.FileName
                };
                await addRecord("RecipientPhotoFile", newRecipientPhotoFile);
            }

            if (signatureImage) {
                session.RecipientSignatureFileID = RecipientSignatureFileID;
                const newRecipientSignatureFile = {
                    ID: RecipientSignatureFileID,
                    SessionID: Number(id),
                    ImageData: sign.ImageData,
                    FileName: sign.FileName
                };
                await addRecord("RecipientSignatureFile", newRecipientSignatureFile);
            }
            session.EndSessionLatitude = latitude;
            session.EndSessionLongitude = longitude;
            session.EndSessionLocation = address ?? userLocation?.address;

            if (sessionDate < today) {
                UpdateRecoveryCallSession(session);
            } else if (sessionDate > today) {
                UpdateAdvancedCallSession(session);
            }

            await updateRecord('session', session);

            if (order && !isOnlineOrder) {
                await updateRecord('Orders', {
                    ...order,
                    Status: orderStatus.Submitted
                })
            }

            await DeductSampleStocks(Number(id));
            if (isOnline && hasInternet) {
                await ClearSessionLocalData(Number(id));
            }

            localStorage.setItem("preventNavigation", true);
            window.dispatchEvent(new Event("session"));
            await fetchData();

            setModalOpen(false);
            setShowConfirmFinishSession(true);
            if (addNotes) {
                setIsAddNote(true);
            }
        } catch (err) {
            console.log(err);
            setValidationMessage("Error End Session!");
            setShowValidation(true);
        } finally {
            isRunningRef.current = false;
            setIsFinishing(false);
            setIsSidebarCollapsed(false);
            setStartTime(null);
        }
    }, [
        id,
        isOnline,
        hasInternet,
        fetchData,
        setIsAddNote,
        setIsFinishing,
        setShowLocationMesaage,
        setValidationMessage,
        setShowValidation,
        setModalOpen,
        setShowConfirmFinishSession,
        setSignData,
        setPhotoImgData,
        setIsSidebarCollapsed,
        setStartTime
    ]);

    const OnlineEndSession = async (ses, loc, sign, img) => {
        try {
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");

            const sampleList = await getAll("sessionItems");
            const inventoryList = await getAll("SessionInventory");
            const withdrawalList = await getAll("SessionWithdrawal");
            const noteList = await getAll("sessionNotes");
            const orderList = await getAll("Orders");
            const orderDetailList = await getAll("OrderDetails");

            const samples = sampleList.filter((a) => a.SessionID === Number(id) && a.SyncStatus !== SyncStatusMap.done);
            const inventory = inventoryList.filter((a) => a.SessionID === Number(id) && a.SyncStatus !== SyncStatusMap.done);
            const withdrawals = withdrawalList.filter((a) => a.SessionID === Number(id) && a.SyncStatus !== SyncStatusMap.done);
            const notes = noteList.filter((a) => a.SessionID === Number(id) && a.SyncStatus !== SyncStatusMap.done);
            const order = orderList.find((a) => a.SessionID === Number(id) && a.Status === orderStatus.Draft && a.SyncStatus !== SyncStatusMap.done);
            const orderDetails = orderDetailList.filter((a) => a.OrderID === order?.ID);

            const formattedSamples = samples.map(s => ({
                ID: s.ID,
                ItemID: s.ItemID,
                UnitID: s.UnitID,
                Quantity: s.Executed,
                Remarks: s.Remarks
            }));

            const formattedInventory = inventory.map(s => ({
                ID: s.ID,
                ItemID: s.ItemID,
                UnitID: s.UnitID,
                Quantity: s.Executed,
                Lot: s.Lot,
                Expiry: s.ExpiryDate ? new Date(s.ExpiryDate).toISOString().slice(0, 7) : null,
                StockRoom: s.StockRoomOnHand,
                Shelf: s.ShelfOnHand,
                Remarks: s.Remarks,
                Availability: s.Availability
            }));

            const formattedWithdrawals = withdrawals.map(s => ({
                ID: s.ID,
                ItemID: s.ItemID,
                UnitID: s.UnitID,
                Quantity: s.Executed,
                Lot: s.Lot,
                Expiry: s.ExpiryDate ? new Date(s.ExpiryDate).toISOString().slice(0, 7) : null,
                StockRoom: s.StockRoomOnHand,
                Shelf: s.ShelfOnHand,
                Remarks: s.Remarks,
                Availability: s.Availability
            }));

            const formattedOrders = order
                ? {
                    ID: order.ID?.toString(),
                    OrderDate: order.OrderDate,
                    AccountID: order.Account?.ID.toString(),
                    Address: order.DeliveryAddress,
                    Remarks: order.Remarks,
                    Authorizer: order.Authorizer,
                    Status: order.Status.toString(),

                    Items: orderDetails.map(d => ({
                        ID: d.ID?.toString(),
                        ItemID: d.Item.ID?.toString(),
                        UnitID: d.Unit.ID?.toString(),
                        DetailPrice: String(d.DetailPrice ?? 0),
                        Quantity: String(d.Quantity ?? 0),
                        FreeGoods: String(d.FreeGoods ?? 0),
                        Discount: String(d.DiscountPercent ?? 0),
                        Remarks: d.Remarks || ""
                    }))
                }
                : null;

            const formattedNotes = [];

            const formData = new FormData();
            formData.append("id", ses.ID);
            formData.append("v", ses?.VersionID);
            formData.append("loc", JSON.stringify(loc));
            if (sign?.ImageData) {
                formData.append("sign_img", sign.ImageData, sign.FileName);
            } else {
                formData.append("sign_img", null);
            }

            // Append photo image
            if (img?.ImageData) {
                formData.append("photo_img", img.ImageData, img.FileName);
            } else {
                formData.append("photo_img", null);
            }
            formData.append("samples", JSON.stringify(formattedSamples));
            formData.append("inventory", JSON.stringify(formattedInventory));
            formData.append("withdrawals", JSON.stringify(formattedWithdrawals));
            formData.append("notes", JSON.stringify(formattedNotes));

            if (formattedOrders) {
                formData.append("orders", JSON.stringify(formattedOrders));
            }

            const response = await fetch(appURL.API_EndSession, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "X-ETR-Device-ID": devId
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {
                if (data?.code) {
                    return { error: data?.description || "Session failed to end." };
                } else {
                    return { error: "Unexpected server error." };
                }
            }

            return {
                serverDate: data?.server_date,
                duration: data?.duration
            };

        } catch (error) {
            return { error: error };
        }
    };

    const DeductSampleStocks = async (sessionId) => {
        try {
            const sampleList = await getAll("sessionItems");
            const stocks = await getAll("StockAllocations");

            const samples = sampleList.filter((a) => a.SessionID === sessionId && a.SyncStatus !== SyncStatusMap.done);

            for (const sample of samples) {
                const stock = stocks.find(
                    (s) =>
                        s.ItemID === sample.ItemID &&
                        s.UnitID === sample.UnitID &&
                        s.Type === StockAllocationType.Samples
                );

                if (stock) {
                    const executed = Number(sample.Executed) || 0;

                    const updatedStock = {
                        ...stock,
                        Stock: (Number(stock.Stock) || 0) - executed,
                        Allocated: (Number(stock.Allocated) || 0) - executed
                    };

                    await updateRecord("StockAllocations", updatedStock);
                }
            }

        } catch (err) {
            console.log(err);
        }
    };

    const handleSubmitOrder = async (orderID, sign) => {
        try {
            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");

            const formData = new FormData();
            formData.append("id", String(orderID)); // ensure string

            if (sign?.ImageData) {
                formData.append("sign_img", sign.ImageData, sign.FileName);
            }

            const response = await fetch(appURL.API_OrderSubmit, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "X-ETR-DeviceID": devId
                },
                body: formData
            });

            if (!response.ok) {
                const text = await response.text();
                console.error("Submit failed:", text);
                return;
            }

            const _order = await getRecordById("Orders", orderID);

            const updatedOrder = {
                ..._order,
                Status: orderStatus.Submitted
            }

            await updateRecord("Orders", updatedOrder);

        } catch (err) {
            console.error(err);
        }
    };

    const getOrderBySessionId = async (sessionId) => {
        const orders = await getAll("Orders");
        return orders.find(o => o.SessionID === Number(sessionId) && o.Status === orderStatus.Draft);
    };

    const onFinishEvaluation = useCallback(async (answer) => {
        if (isRunningRef.current) return;
        isRunningRef.current = true;

        setIsFinishing(true);
        try {
            // const location = await checkLocationPermission();
            // if (!location) {
            //     setIsFinishing(false);
            //     setShowLocationMesaage(true);
            //     return
            // }

            const session = await getRecordById('session', Number(id));
            if (!session) throw new Error(`Session not found.`);

            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;
            const now = new Date();

            const { latitude, longitude, address } = await getLocation();

            const loc = {
                "lat": latitude,
                "long": longitude
            }


            const ext_id = localStorage.getItem("ext_id");
            const customer = await getRecordById("customer", session.AccountID);
            const formattedDate = formatDateForFilename(now);

            const signatureExt1 = getExtensionFromBlob(answer.first_signature) || 'png';
            const signatureExt2 = getExtensionFromBlob(answer.second_signature) || 'png';

            const sign_1 = {
                ImageData: answer.first_signature || "",
                FileName: `${ext_id}_${formattedDate}_${customer?.Code}.${signatureExt1}`
            }

            const sign_2 = {
                ImageData: answer.second_signature || "",
                FileName: `${ext_id}_${formattedDate}_${customer?.Code}.${signatureExt2}`
            }

            let result = null;
            if (isOnline && hasInternet) {
                result = await OnlineEndEvaluation(session, loc, sign_1, sign_2, answer);
                if (result?.error) {
                    setValidationMessage(result.error);
                    setShowValidation(true);
                    return; //
                }
            } else if (!isOnline || !hasInternet) {
                session.SyncStatus = SyncStatusMap.update;
            }

            const RecipientSignatureFileID = await getNextId("RecipientSignatureFile");
            const SessionEvaluationID = await getNextId("SessionEvaluations");

            const sessionDate = new Date(session.SessionDate);
            sessionDate.setHours(0, 0, 0, 0);

            session.ActualEnd = result?.serverDate ?? now.toISOString();

            const start = new Date(session.ActualStart);
            const end = new Date(now.toISOString());

            const durationMs = end - start;
            const totalSeconds = +(durationMs / 1000).toFixed(4);

            session.Duration = result?.duration ?? totalSeconds;

            const today = now.setHours(0, 0, 0, 0);
            if (sessionDate < today || session.PastDueSessionID) {
                session.Status = statusMapping.recovered;
            } else if (sessionDate > today || session.PastDueSessionID) {
                session.Status = statusMapping.advanced;
            } else {
                session.Status = statusMapping.success;
            }

            const newRecipientSignatureFile1 = {
                ID: RecipientSignatureFileID,
                SessionID: Number(id),
                ImageData: answer.first_signature || "",
                FileName: `${ext_id}_${formattedDate}_${customer?.Code}.${signatureExt1}`
            };

            const newRecipientSignatureFile2 = {
                ID: RecipientSignatureFileID + 1,
                SessionID: Number(id),
                ImageData: answer.second_signature || "",
                FileName: `${ext_id}_${formattedDate}_${customer?.Code}.${signatureExt2}`
            };

            const newSessionEvaluation = {
                ID: SessionEvaluationID,
                ExternalID: ext_id,
                SessionID: session.ID,
                EvaluationDate: new Date(now.toISOString()),
                EvaluationDataJson: {
                    ...answer,
                    first_signature: RecipientSignatureFileID,
                    second_signature: RecipientSignatureFileID + 1
                },
                Grade: answer.final_grade
            }

            session.EndSessionLatitude = latitude;
            session.EndSessionLongitude = longitude;
            session.EndSessionLocation = address ?? userLocation?.address;

            await addRecord("RecipientSignatureFile", newRecipientSignatureFile1);
            await addRecord("RecipientSignatureFile", newRecipientSignatureFile2);
            await addRecord("SessionEvaluations", newSessionEvaluation);

            if (sessionDate < today) {
                UpdateRecoveryCallSession(session);
            } else if (sessionDate > today) {
                UpdateAdvancedCallSession(session);
            }

            await updateRecord('session', session);
            window.dispatchEvent(new Event("session"));

            await fetchData();
            setShowEvaluation(false);
            setShowConfirmFinishEvaluation(true);
        } catch (err) {
            setValidationMessage("Error Finish Evaluation");
            setShowValidation(true);
        } finally {
            isRunningRef.current = false;
            setIsFinishing(false);
            setIsSidebarCollapsed(false);
            setStartTime(null);
        }
    }, [id,
        fetchData,
        ext_id,
        setIsFinishing,
        setShowLocationMesaage,
        setValidationMessage,
        setShowValidation,
        setShowEvaluation,
        setShowConfirmFinishEvaluation,
        setIsSidebarCollapsed,
        setStartTime
    ]);

    const transformEvaluation = (evaluation, template) => {
        const {
            first_signature,
            second_signature,
            clients,
            factors,
            final_grade,
            general_evaluation,
            ...rest
        } = evaluation;

        return {
            AgentSessionIds: clients.map(c => c.sessionID),
            Evaluation: JSON.stringify({
                comment: general_evaluation,
                clients: clients.map(c => c.id),
                factors: factors
            }),
            TemplateID: template.ID,
            Grade: final_grade
        };
    };

    const OnlineEndEvaluation = async (ses, loc, sign, sign2, evaluation) => {
        try {

            const rawTemplate = await getAll("EvaluationTemplates");
            const template = rawTemplate?.[0] || null;
            // const { first_signature, second_signature, ...cleanedEvaluation } = evaluation;
            const cleanedEvaluation = transformEvaluation(evaluation, template);

            const token = localStorage.getItem("token");
            const devId = localStorage.getItem("devId");

            const formData = new FormData();
            formData.append("id", ses.ID);
            formData.append("v", ses?.VersionID);
            formData.append("loc", JSON.stringify(loc));
            formData.append("sign_img_agent", sign.ImageData, sign.FileName);
            formData.append("sign_img", sign2.ImageData, sign2.FileName);
            formData.append("evaluation", JSON.stringify(cleanedEvaluation));
            formData.append("grade", evaluation.final_grade);

            const response = await fetch(appURL.API_EndSession, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "X-ETR-Device-ID": devId
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {
                if (data?.code) {
                    return { error: data?.description || "Session failed to end." };
                } else {
                    return { error: "Unexpected server error." };
                }
            }

            return {
                serverDate: data?.server_date,
                duration: data?.duration
            };

        } catch (error) {
            return { error: "Evaluation failed to end" };
        }
    };

    function formatTime(timeString) {
        if (!timeString) return "";

        const [hours, minutes] = timeString.split(":");
        const date = new Date();
        date.setHours(+hours);
        date.setMinutes(+minutes);
        date.setSeconds(0);

        return date.toLocaleTimeString([], {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).toLowerCase();
    }

    const getSessionAction = () => {
        const isEvaluation = selectedSession?.Customer?.Type === accountMapping.Agent && permission?.coverage?.joint_calls;

        if (selectedSession?.Status === statusMapping.pending) {
            return {
                type: "start",
                title: isEvaluation ? "Start Evaluation" : "Start Session",
                bodyText: isEvaluation
                    ? "Are you sure you want to start the evaluation?"
                    : "Are you sure you want to start the session?",
                confirmText: isEvaluation
                    ? "Yes! Start Evaluation"
                    : "Yes! Start Session",
                onConfirm: handleStart
            };
        }

        if (selectedSession?.Status === statusMapping.inprogress) {
            return {
                type: "end",
                title: isEvaluation ? "End Evaluation" : "End Session",
                bodyText: isEvaluation
                    ? "Are you sure you want to end the evaluation?"
                    : "Are you sure you want to finish this session?",
                confirmText: isEvaluation
                    ? "Yes! End Evaluation"
                    : "Yes! Finish Session",
                onConfirm: handleEnd
            };
        }

        return null;
    };

    const sessionAction = getSessionAction();

    const getBrowserInstructions = () => {
        const userAgent = navigator.userAgent;

        if (/Chrome/i.test(userAgent) && !/Edg/i.test(userAgent)) {
            return `<p>Go to <strong>chrome://settings/content/location</strong></p>`;
        } else if (/Edg/i.test(userAgent)) {
            return `<p>Go to <strong>edge://settings/content/location</strong></p>`;
        } else if (/Safari/i.test(userAgent) && /iPhone|iPad|iPod/i.test(userAgent)) {
            return `<p>Go to <strong>Settings > Safari > Location</strong></p>`;
        } else if (/Firefox/i.test(userAgent)) {
            return `<p>Go to <strong>Settings > Privacy & Security > Permissions > Location</strong></p>`;
        } else {
            return `<p>Your browser is blocking location access. Please check your browser settings to allow location permission.</p>`;
        }
    };

    useEffect(() => {
        if (!selectedSession) return;

        if (selectedSession?.Status === statusMapping.pending) {
            setActiveTab(CallPhase.PreCall);
        }
        else if (selectedSession.Status === statusMapping.inprogress) {
            setActiveTab(CallPhase.ActualCall);
        }
        else if (
            selectedSession?.Status === statusMapping.success ||
            selectedSession?.Status === statusMapping.recovered ||
            selectedSession?.Status === statusMapping.advanced
        ) {
            setActiveTab(CallPhase.PostCall);
        } else {
            setActiveTab(CallPhase.PreCall);
        }
    }, [selectedSession]);

    return (
        <div className="opal-coverage-view h-100 w-100">
            {sidebarLoading ?
                <div className="d-flex align-items-center justify-content-center h-100 ">
                    <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
                </div> :
                <>
                    <div className="tcv-header p-3 d-flex flex-nowrap align-items-center">
                        <div className="d-none d-md-flex h-100">
                            <TauriImage localImage={"/Images/no-image.png"} alt="profile" className={'header-img'} />
                        </div>
                        <div className="section1 flex-grow-1 px-3 h-100" onClick={() => setShowAccountSidebar(true)}>
                            <h5 className="mb-2">
                                <span className="tcv-name">{selectedSession?.Customer?.Name?.toUpperCase()}</span>
                                {/* <span className="tcv-code ms-2">{details?.Code ? `(${details.Code})` : ''}</span> */}
                            </h5>
                            <p className="m-0 d-none d-md-flex align-items-center">
                                {selectedSession?.SessionNumber && <TauriImage localImage={'/Images/carbon--settings.svg'} className={'tcv-icon'} />}
                                <div className="me-4">{selectedSession?.SessionNumber?.toUpperCase()}</div>

                                {selectedSession?.Customer?.Class && <TauriImage localImage={'/Images/material-symbols--call-split.svg'} className={'tcv-icon'} />}
                                <div>
                                    {selectedSession?.Customer?.Class?.toUpperCase()}
                                    {selectedSession?.Customer?.Frequency_code &&
                                        <span className="ms-1">({selectedSession?.Customer.Frequency_code.toUpperCase()})</span>
                                    }
                                </div>
                            </p>
                            <div>
                                <div className="m-0 d-none d-md-flex align-items-center">
                                    {(selectedSession?.Customer?.Area || selectedSession?.Customer?.Day_call || selectedSession?.Customer?.Time_call) && (
                                        <TauriImage localImage={'/Images/solar--map-point-bold.svg'} className={'tcv-icon'} />
                                    )}
                                    <div>
                                        <div>{selectedSession?.Customer?.Area}</div>
                                        <div className="d-flex">
                                            <div className="tcv-bold me-1">{selectedSession?.Customer?.Day_call}</div>
                                            <div>{formatTime(selectedSession?.Customer?.Time_Start)} - {formatTime(selectedSession?.Customer?.Time_End)}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="section2 d-flex flex-column justify-content-between">
                            <div className="d-flex flex-column align-items-end">
                                {details?.contact_no?.split(',').map((num, index) => (
                                    <div key={index} className="d-flex align-items-center mb-1">
                                        {index === 0 && (
                                            <TauriImage
                                                localImage={'/Images/material-symbols--contact-phone-outline-rounded.svg'}
                                                className={'tcv-icon'}
                                            />
                                        )}
                                        <div className="c-number">{num.trim()}</div>
                                    </div>
                                ))}
                            </div>

                            <div className="d-flex justify-content-end d-none d-md-flex">
                                <Dropdown className="account-schedule-dropdown">
                                    <Dropdown.Toggle className="account-schedule-toggle">
                                        <TauriImage
                                            localImage={"/Images/f7--calendar-today.svg"}
                                            alt="calendar"
                                        />
                                        Schedules
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="p-2 account-schedule-dropdown-menu">
                                        {isLoadingAccountSchedules ? (
                                            <TauriLoader2 width="2rem" height="2rem" borderwidth="0.35rem" color="#1D5D9B" />
                                        ) : (
                                            accountSchedules.map((item, index) => (
                                                <Dropdown.Item
                                                    key={item.ID}
                                                    className={`d-flex align-items-center schedule-item p-2 ${index % 2 === 1 ? '' : 'alt-bg'}`}
                                                    onClick={() => handleSelectSchedule(item)}>

                                                    {item?.Joint && (
                                                        <TauriImage
                                                            localImage="/Images/mdi--handshake-outline.svg"
                                                            alt="jointcall"
                                                            className="idp-icon"
                                                        />
                                                    )}
                                                    <TauriImage
                                                        localImage={statusIcon[item?.Status]}
                                                        alt={`status-${item?.Status}`}
                                                        className="idp-icon"
                                                    />
                                                    <span>{formatSchedulesDisplayDate(item.SessionDate)}</span>
                                                </Dropdown.Item>
                                            )))
                                        }
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>


                            {sessionAction ? (
                                <Button
                                    className={`btn px-4 mt-auto text-nowrap d-flex justify-content-center ${sessionAction.type === "end" ? "btn-end" : "btn-start"}`}
                                    size="sm"
                                    onClick={() => setShowConfirm(true)}
                                    disabled={!timeIn || timeOut || isSync}
                                >
                                    {sessionAction.type === "end" ? "End Session" : "Start Session"}
                                </Button>
                            ) : selectedSession?.Status === statusMapping.cancelled ? (
                                <div className="display-status mt-auto text-end">
                                    <div className="missed">APPROVED MISSED CALL</div>
                                    <div>{missedCallReason?.Description}</div>
                                </div>
                            ) : ((selectedSession?.Status === statusMapping.success ||
                                selectedSession?.Status === statusMapping.recovered ||
                                selectedSession?.Status === statusMapping.advanced) && (
                                    <div className="display-status mt-auto text-end">
                                        <div className="completed">SESSION COMPLETED</div>
                                        <div className="ses-time d-flex align-items-center justify-content-end">
                                            {selectedSession?.Joint && (
                                                <TauriImage
                                                    localImage="/Images/mdi--handshake-outline.svg"
                                                    alt="jointcall"
                                                    className="sidebar-icon me-1"
                                                />
                                            )}
                                            <TauriImage
                                                localImage={statusIcon[selectedSession?.Status]}
                                                alt={`status-${selectedSession?.Status}`}
                                                className="sidebar-icon me-1"
                                            />
                                            <div>{formattedDisplayDate(selectedSession?.ActualEnd)}</div>
                                        </div>

                                    </div>
                                )
                            )}
                        </div>
                    </div>
                    <div className="tcv-body p-3">
                        <Nav
                            variant="tabs"
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(Number(k))}
                            className="coverage-nav-tabs mb-2"
                        >
                            <Nav.Item>
                                <Nav.Link eventKey={CallPhase.PreCall}>
                                    Pre Call
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={CallPhase.ActualCall}>
                                    Actual Call
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link eventKey={CallPhase.PostCall}>
                                    Post Call
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        {filteredSections.map((section, index) => (
                            <OpalCoverageFactory key={index} section={section} id={Number(id)} callPhase={activeTab} />
                        ))}
                    </div>
                </>
            }
            {sessionAction && (
                <OpalAlertModal
                    show={showConfirm}
                    onHide={() => setShowConfirm(false)}
                    title={sessionAction.title}
                    bodyText={sessionAction.bodyText}
                    onConfirm={sessionAction.onConfirm}
                    confirmButtonText={sessionAction.confirmText}
                    cancelButtonText="No"
                    modalType="question"
                    loading={isLoading}
                />
            )}

            <FinishSessionModal show={modalOpen} onHide={setModalOpen} id={Number(id)} onFinishSession={onFinishSession} isFinishing={isFinishing} />
            <AddRemarks show={showAddNotes} onHide={setShowAddNotes} onRemarks={handleRemarks} loading={loadingAddNotes} noInventory={noInventory} />

            <OpalAlertModal
                show={showConfirmFinishSession}
                onHide={() => {
                    setShowConfirmFinishSession(false);
                    setShowAddNotes(isAddNote);
                }}
                title={"Finished"}
                bodyText={"Session Finished"}
                cancelButtonText="No"
                modalType="message"
                Icon="/Images/material-symbols--check-finished.svg"
            />

            <OpalAlertModal
                show={showConfirmFinishEvaluation}
                onHide={() => {
                    setShowConfirmFinishEvaluation(false);
                }}
                title={"Submitted"}
                bodyText={"Evaluation has been submitted successfully."}
                subBodyText={"Press anywhere to close this window."}
                cancelButtonText="No"
                modalType="message"
                Icon="/Images/material-symbols--check-finished.svg"
                hideFooter={true}
            />

            <OpalAlertModal
                show={showLocationMesaage}
                onHide={() => setShowLocationMesaage(false)}
                title={"Allow Location Access"}
                bodyText={getBrowserInstructions()}
                modalType="message"
            />

            <OpalAlertModal
                show={showValidation}
                onHide={() => {
                    setShowValidation(false);
                }}
                title={"Message"}
                bodyText={validationMessage}
                modalType="message"
            />
            <OpalAdvancedCallModal
                show={showAdvancedCall}
                onHide={() => setShowAdvancedCall(false)}
                session={item}
            />
            <EvaluationSessionModal
                show={showEvaluation}
                onHide={() => setShowEvaluation(false)}
                account={details}
                session={item}
                onFinishEvaluation={onFinishEvaluation}
                isFinishing={isFinishing}
            />
            <AccountSidebar
                open={showAccountSidebar}
                onClose={() => setShowAccountSidebar(false)}
                accID={item?.AccountID}
            />
        </div>
    )
}

export default CoverageView